"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIContentStructureEndpointKeys = void 0;
var AIContentStructureEndpointKeys;
(function (AIContentStructureEndpointKeys) {
    AIContentStructureEndpointKeys["PostAIContentStructure"] = "ai.content.structure.post";
})(AIContentStructureEndpointKeys || (exports.AIContentStructureEndpointKeys = AIContentStructureEndpointKeys = {}));
